import store from '@/store'

export default [
  {
    path: '/warehouses',
    name: 'warehouse',
    meta: { requiresAuth: true },
    component: () => import('@/pages/warehouse/form.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/warehouses/:id',
    name: 'warehouse-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/warehouse/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('warehouse/find', to.params.id)
      next()
    }
  }
]
